import { render, staticRenderFns } from "./SymbolNewsFeedItem.vue?vue&type=template&id=15237b6e&scoped=true&"
import script from "./SymbolNewsFeedItem.vue?vue&type=script&lang=js&"
export * from "./SymbolNewsFeedItem.vue?vue&type=script&lang=js&"
import style0 from "./SymbolNewsFeedItem.vue?vue&type=style&index=0&id=15237b6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15237b6e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VCard,VFlex,VHover,VIcon,VOverlay,VSpacer,VSubheader})
